// src/Lib/EDVApiClient.ts

import Globals from "../Globals"

type ApiClientOptions = Omit<RequestInit, 'headers'> & {
    headers?: Record<string, string>;
    tenant?: string
};

/**
 * Effectue un appel fetch typé vers l'API et gère les erreurs
 * @param url L’URL complète de la ressource
 * @param options Options fetch (headers, method, body, etc.)
 * @returns Le corps de réponse parsé en JSON
 */
export async function apiFetch<T = unknown>(
    url: string,
    options: ApiClientOptions = {},
): Promise<T> {
    const defaultHeaders: Record<string, string> = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-API-Key': Globals.API_KEY,
        'X-Client-ID': localStorage.user_IDClient,
        'X-Login': localStorage.user_login,
        'X-Password': localStorage.user_password,
    }

    const allHeaders = {
        ...defaultHeaders,
        ...options.headers,
    }

    const fetchOptions: RequestInit = {
        ...options,
        headers: allHeaders,
    }

    let response: Response
    try {
        response = await fetch(url, fetchOptions)
        if (!response.ok) {
            const errorText = await response.text().catch(() => '')
            throw new Error(
                `HTTP ${response.status} – ${response.statusText} : ${errorText}`,
            )
        }
        return response.json() as Promise<T>
    } catch (err: any) {
        throw new Error(`Erreur: ${err.message}`)
    }

}

/**
 * Appelle la nouvelle API centrale avec gestion automatique du endpoint
 * @param endpoint Chemin (ex: "/users")
 * @param options Options supplémentaires
 * @param tenant Nom du tenant (ex: "test", "demo", "edv")
 * @returns Réponse typée
 */
export async function callEDataVoiceApi<T = unknown>(
    endpoint: string,
    options?: ApiClientOptions,
): Promise<T> {
    let parts = window.location.hostname.split('.')

    let ApiUrl = ''
    if (endpoint.startsWith('http')) {
        ApiUrl = ''
    } else {
        let tenant = parts[0]
        if (options && options.tenant) {
            tenant = options.tenant
        }

        // production
        ApiUrl = 'https://' + tenant + Globals.EDV_API_URL

        // local
        if (tenant === 'localhost' || parts[parts.length - 1] === 'test') {
            ApiUrl = 'https://'+ tenant + Globals.EDV_API_URL_LOCAL
        }
        //Staging
        else if (tenant === 'dev' || parts[1] === 'dev' || tenant === 'preprod' || parts[1] === 'preprod') {
            ApiUrl = 'https://' + tenant + Globals.EDV_API_URL_DEV
        }
    }

    return apiFetch<T>(ApiUrl + endpoint, options)
}

export async function callEDataVoiceApiPaginate<T = unknown>(url: string, options?: ApiClientOptions): Promise<T> {
    return apiFetch(url, options)
}
